import React, { useState, useRef, useEffect } from 'react';
import './AppLauncherModal.css';
import slidesIcon from '../../assets/DasboardIcons/slides.svg';
import boardIcon from '../../assets/DasboardIcons/board.png';
import mindmapIcon from '../../assets/DasboardIcons/mindmap.svg';
import ideationIcon from '../../assets/DasboardIcons/ideation.svg';
import spacesIcon from '../../assets/DasboardIcons/spaces.svg';
import padIcon from '../../assets/DasboardIcons/pad.png';
import gridIcon from '../../assets/DasboardIcons/grid.png';
import moodIcon from '../../assets/DasboardIcons/mood.png';

const AppLauncherModal = ({ scale = 1 }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (open && ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const apps = [
    { id: 'pad', name: 'Pad', icon: padIcon, url: 'https://pad.workw.com/' },
    { id: 'grid', name: 'Grid', icon: gridIcon, url: 'https://grid.workw.com/' },
    { id: 'board', name: 'Board', icon: boardIcon, url: 'https://board.workw.com/' },
    { id: 'mindmap', name: 'Mindmap', icon: mindmapIcon, url: 'https://map.workw.com/' },
    { id: 'ideation', name: 'Ideation', icon: ideationIcon, url: 'https://ideation.workw.com/' },
    { id: 'spaces', name: 'Spaces', icon: spacesIcon, url: 'https://spaces.workw.com/' },
    { id: 'mood', name: 'Mood', icon: moodIcon, url: 'https://mood.workw.com/' },
  ];

  const handleAppClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    setOpen(false);
  };

  const wrapperStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  };

  return (
    <div
      className="app-launcher-root"
      ref={ref}
      style={wrapperStyle}
    >
      <button
        className="app-launcher-btn"
        onClick={() => setOpen(!open)}
        aria-label="Workwise apps"
        title="Workwise apps"
      >
        <svg className="app-launcher-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
        </svg>
      </button>

      {open && (
        <div className="app-launcher-dropdown">
          <div className="app-launcher-grid">
            {apps.map((app) => (
              <button
                key={app.id}
                className="app-launcher-item"
                onClick={() => handleAppClick(app.url)}
                title={app.name}
              >
                <div className="app-launcher-item-icon">
                  <img src={app.icon} alt={app.name} />
                </div>
                <span className="app-launcher-item-name">{app.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AppLauncherModal;
